import React, { useEffect, useContext } from "react";
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { makeStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Checkbox from "@material-ui/core/Checkbox";
import FormHelperText from "@material-ui/core/FormHelperText";
import Select from 'react-select';
import { ValidSelect } from "beaktShared/helpers/validselect";
import CircularProgress from '@material-ui/core/CircularProgress';
import { MaskMoney, transformValueFormatedtoFloat, transformValueFloattoFormated, MaskOnlyNumbers } from "beaktShared/helpers/masks";


// icons
import PermIdentity from "@material-ui/icons/PermIdentity";
import Check from "@material-ui/icons/Check";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Clearfix from "beaktShared/components/Clearfix/Clearfix.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";
import { UseGetApiSimple } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";

import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
const useStyles = makeStyles(styles);

export default function ServicoForm({ addItem, item, handleView, loading }) {
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    const classes = useStyles();
    const { register, handleSubmit, setValue, errors, clearError, getValues } = useForm({ mode: "onChange" });
    const [ativoCheckbox, setAtivoCheckbox] = React.useState(true);
    const [bloqueadoVenda, setBloqueadoVenda] = React.useState(false);
    const [incluirRoyaltieCheckbox, setIncluirRoyaltieCheckbox] = React.useState(true);

    const intialValues = {
        id: 0,
        descricao: '',
        ativo: false,
        tempoExecucao: '',
        valor: ''
    };

    const [notification, setNotification] = React.useState({
        show: false,
        color: 'info',
        message: ""
    });

    useEffect(() => {
        UseGetApiSimple("Franquias/GetByEstabelecimento/" + session.estabelecimentoId).then((result) => {
            if (result.status == 200) {
                session.franquiaId = result.data.franquiaId;
                if (!item.servicoId && session.franquiaId === 1) {
                    setNotification({
                        show: true,
                        message: "Ao adquirir Semaglutida/Tirzepatida, é obrigatória a assinatura do serviço de telemedicina para prescrição e acompanhamento."
                    });
                }
            }
        });

    }, [item])

    useEffect(() => {
        LoadSelectEspecialidades();
        LoadSelectClausulas();
        if (session.estabelecimentoId === 0) {
            setshowSelectEstabelecimento(true);
            loadSelectEstabelecimentos();
        }
    }, []);
    const [especialidade, setEspecialidade] = React.useState("");
    const [listSelectEspecialidade, setListSelectEspecialidade] = React.useState([]);
    const [loadingSelectEspecialidade, setloadingSelectEspecialidade] = React.useState(false);
    const handleEspecialidadeChange = event => {
        let value = event
        setEspecialidade(value);
        setValue("especialidade", value);
        if (value !== "")
            clearError("especialidade");
    };
    const getEndPoint = () => {
        let endPointGet = "";
        if (session.estabelecimentoId === 0) //Acessando tela pelo modulo matriz
            endPointGet = "especialidades/ativos/byfranquia/" + session.franquiaId;
        else //Acessando tela pelo modulo Clinica   
            endPointGet = "especialidades/ativos/byestabelecimento/" + session.estabelecimentoId;
        return endPointGet;
    }
    const LoadSelectEspecialidades = () => {
        setloadingSelectEspecialidade(true);
        const endPoint = getEndPoint();
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                //showNotification(result.message,'danger');  
                setloadingSelectEspecialidade(false);
                return false;
            }
            setListSelectEspecialidade(result.data);
            setloadingSelectEspecialidade(false);
            return true;
        });
    }

    //Carrega clausulas
    const [clausulaContrato, setclausulaContrato] = React.useState("");
    const [listSelectClausula, setlistSelectClausula] = React.useState([]);
    const [loadingSelectClausula, setloadingSelectClausula] = React.useState(false);

    const LoadSelectClausulas = () => {
        setloadingSelectClausula(true);
        const endPoint = "clausulaContrato/byServicoPacote/" + session.estabelecimentoId + "/" + session.franquiaId;
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                //showNotification(result.message,'danger');  
                setloadingSelectClausula(false);
                return false;
            }

            let list = [{ clausulaContratoId: null, descricao: "Nenhum" }, ...result.data]
            setlistSelectClausula(list);
            setloadingSelectClausula(false);
            return true;
        });
    }

    const handleClausulaChange = event => {
        let value = event
        setclausulaContrato(value);
        setValue("clausulaContrato", value);
        if (value !== "")
            clearError("clausulaContrato");
    };

    const [showSelectEstabelecimento, setshowSelectEstabelecimento] = React.useState(false);
    const [listSelectEstabelecimentos, setlistSelectEstabelecimentos] = React.useState([]);
    const [listSelectEstabelecimentosSelected, setlistEstabelecimentosSelected] = React.useState([]);
    const [estabelecimentos, setestabelecimentos] = React.useState([]);
    const [loadingSelectEstabelecimentos, setloadingSelectEstabelecimentos] = React.useState(false);
    const loadSelectEstabelecimentos = () => {
        setloadingSelectEstabelecimentos(true);
        const endPoint = "estabelecimentos/ativos/byfranquia/" + session.franquiaId;
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                //showNotification(result.message,'danger');  
                setloadingSelectEstabelecimentos(false);
                return false;
            }
            setlistSelectEstabelecimentos(result.data);
            setloadingSelectEstabelecimentos(false);
            return true;
        });
    }
    const handleEstabelecimentoChange = event => {
        let value = event
        let data = getValues()

        let lstsAdd = [];
        let lstSelect = [];
        value.map(item => {
            lstsAdd.push(item.estabelecimentoId);

            lstSelect.push({
                estabelecimentoId: item.estabelecimentoId,
                produtoId: data.id
            });
        });
        setestabelecimentos(lstsAdd);
        setlistEstabelecimentosSelected(lstSelect);

    };
    const handleClickSelecionarTodosEstabelecimentos = () => {

        let data = getValues()
        let lstsAdd = [];
        let lstSelect = [];
        listSelectEstabelecimentos.map(item => {
            lstsAdd.push(item.estabelecimentoId);

            lstSelect.push({
                estabelecimentoId: item.estabelecimentoId,
                produtoId: data.id
            });
        });
        setestabelecimentos(lstsAdd);
        setlistEstabelecimentosSelected(lstSelect);
    }

    const [boletimOcorrencia, setboletimOcorrencia] = React.useState(null);
    const loadBoletimOcorrencia = () => {
        UseGetApiSimple("boletimocorrencia/ultimoboletimservico/" + item.servicoId, 0).then(result => {
            if (result.status !== 200) {
                return false;
            }
            if (result.data != null && result.data.aprovado != true) {
                setboletimOcorrencia({
                    color: result.data.aprovado == null ? "warning" : "danger",
                    message: result.data.aprovado == null ? t('information_message.service_blocked_by_array') : (t('information_message.service_blocked_by_array') + ": " + result.data.motivoReprova),
                })
            }
        });
    }

    useEffect(() => {
        if (!item.servicoId)
            return;
        setValue('id', item.servicoId);
        setValue('descricao', item.descricao);
        setValue('tempoExecucao', item.tempoExecucao);
        setAtivoCheckbox(item.ativo);
        setEspecialidade(item.especialidadeId);
        setValue("especialidade", item.especialidadeId);
        let valor = transformValueFloattoFormated(item.valor);
        setValue("valor", valor);
        setValue("clausulaContrato", item.clausulaContratoId);
        setclausulaContrato(item.clausulaContratoId);
        loadEstabelecimentosServicosApi(item.servicoId);
        loadBoletimOcorrencia();
        setBloqueadoVenda(item.bloqueadoVenda);
        setIncluirRoyaltieCheckbox(item.incluirRoyaltie);
    }, [item]);

    const loadEstabelecimentosServicosApi = (idServico) => {
        setloadingSelectEstabelecimentos(true);
        const endPoint = "servicos/" + idServico;
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                //showNotification(result.message,'danger');  
                setloadingSelectEstabelecimentos(false);
                return false;
            }
            loadSelectEstabelecimentoView(result.data.estabelecimentoServicos);
            setloadingSelectEstabelecimentos(false);
            return true;
        });
    }

    const loadSelectEstabelecimentoView = (estabelecimentoServicos) => {
        if (estabelecimentoServicos === null)
            return;

        setlistEstabelecimentosSelected(estabelecimentoServicos);

        let lstAdd = [];
        estabelecimentoServicos.map(item => {
            lstAdd.push(item.estabelecimentoId);
        });
        setestabelecimentos(lstAdd);
    }

    const onSubmit = data => {
        let valor = transformValueFormatedtoFloat(data.valor);

        const resultAdd = addItem({
            servicoId: parseInt(data.id),
            descricao: data.descricao,
            ativo: ativoCheckbox,
            ativoDesc: ativoCheckbox ? 'Ativo' : 'Inativo',
            tempoExecucao: parseInt(data.tempoExecucao),
            especialidadeId: data.especialidade,
            usuarioCadastroId: session.id,
            valor: valor,
            estabelecimentoServicos: loadEstabelecimentosServicos(),
            clausulaContratoId: data.clausulaContrato,
            bloqueadoVenda: bloqueadoVenda,
            incluirRoyaltie: incluirRoyaltieCheckbox,
            ...loadDadosMatriz()
        });
    };

    const loadDadosMatriz = () => {

        if (session.estabelecimentoId === 0) //Acessando tela pelo modulo matriz
        {
            let temp = {
                cadastradoFranquia: true,
                franquiaId: session.franquiaId
            }
            return temp;
        }
        else {
            let temp = {
                cadastradoFranquia: false,
            }
            return temp;
        }
    }

    const loadEstabelecimentosServicos = () => {

        if (session.estabelecimentoId === 0) //Acessando tela pelo modulo matriz
        {
            return listSelectEstabelecimentosSelected;
        }
        else {
            let data = getValues()
            var estabelecimentoServicos = [
                {
                    servicoId: parseInt(data.id),
                    estabelecimentoId: session.estabelecimentoId
                }
            ];
            return estabelecimentoServicos;
        }
    }

    const handleViewForm = () => {
        handleView();
    };

    return (
        <div className="maxContent">
            <form onSubmit={handleSubmit(onSubmit)}>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        {notification.show && <SnackbarContent
                            color={notification.color}
                            message={notification.message}
                            closeNotification={() => setNotification({ show: false })}
                            close
                        />}
                        <Card>
                            <CardHeader color="primary" icon>
                                <CardIcon color="primary">
                                    <PermIdentity />
                                </CardIcon>
                                <h4 className={classes.cardIconTitle}>
                                    {t('sidebar.service_register')} - <small>{t('information_message.fill_in_your_details')}</small>
                                    <input className={classes.hidden} defaultValue={intialValues.id} name="id" ref={register} />
                                </h4>
                            </CardHeader>
                            <CardBody>
                                <GridContainer>
                                    {boletimOcorrencia != null &&
                                        <GridItem xs={12} sm={12} md={12}>
                                            <SnackbarContent
                                                message={boletimOcorrencia == null ? "" : boletimOcorrencia.message}
                                                close
                                                color={boletimOcorrencia == null ? "success" : boletimOcorrencia.color}
                                            />
                                        </GridItem>
                                    }
                                    <GridItem xs={12} sm={12} md={9}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                disabled={(item.servicoId !== 0 && item.cadastradoFranquia === false && session.estabelecimentoId !== 0) ? true : false}
                                                error={errors.descricao ? true : false}
                                                label={t('label.description') + " *"}
                                                variant="outlined"
                                                inputRef={register({ required: true })}
                                                name="descricao"
                                                defaultValue={intialValues.descricao}
                                                InputLabelProps={{ shrink: true }}
                                                inputProps={{ maxLength: 150 }}
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.descricao && <span>{t('label.required')}</span>}
                                            </FormHelperText>
                                        </FormControl>
                                    </GridItem>
                                </GridContainer>
                                <GridContainer>
                                    <GridItem xs={12} sm={6} md={3}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                error={errors.tempoExecucao ? true : false}
                                                label={t('label.run_time') + " (" + t('label.minutes') + ")*"}
                                                variant="outlined"
                                                inputRef={register({ required: true })}
                                                name="tempoExecucao"
                                                defaultValue={intialValues.tempoExecucao}
                                                InputLabelProps={{ shrink: true }}
                                                inputProps={{ maxLength: 3 }}
                                                onInput={(e) => MaskOnlyNumbers(e)}
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.tempoExecucao && <span> {t('label.required')} </span>}
                                            </FormHelperText>
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={6}>

                                        <FormControl fullWidth className={classes.formControl}>

                                            <label className={errors.especialidade ? "select__label select__label_error" : "select__label"}>{t('label.specialty')} *</label>
                                            <Select
                                                classNamePrefix="select"
                                                styles={ValidSelect(errors.especialidade ? true : false)}
                                                isSearchable={true}
                                                isLoading={loadingSelectEspecialidade}
                                                name="especialidade"
                                                placeholder={t('label.select') + " ..."}
                                                options={listSelectEspecialidade}
                                                value={listSelectEspecialidade.filter(({ especialidadeId }) => especialidadeId === especialidade)}
                                                getOptionLabel={({ descricao }) => descricao}
                                                getOptionValue={({ especialidadeId }) => especialidadeId}
                                                onChange={(value) => handleEspecialidadeChange(value.especialidadeId !== null ? value.especialidadeId : "")}
                                                ref={() => register(
                                                    { name: "especialidade" },
                                                    { required: true })
                                                }
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.especialidade && <span>{t('label.required')}</span>}
                                            </FormHelperText>
                                        </FormControl>
                                    </GridItem>
                                </GridContainer>
                                <GridContainer>
                                    <GridItem xs={12} sm={6} md={3}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                label={t('label.value') + " *"}
                                                name="valor"
                                                inputRef={register({ required: true })}
                                                error={errors.valor ? true : false}
                                                defaultValue={intialValues.valor}
                                                InputProps={{
                                                    inputComponent: MaskMoney,
                                                }}
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.valor && <span>{t('label.required')}</span>}
                                            </FormHelperText>
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={4}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    tabIndex={-1}
                                                    checked={ativoCheckbox}
                                                    onClick={event => { setAtivoCheckbox(event.target.checked) }}
                                                    checkedIcon={<Check className={classes.checkedIcon} />}
                                                    icon={<Check className={classes.uncheckedIcon} />}
                                                    classes={{ checked: classes.checked, root: classes.checkRoot }}
                                                    name="ativo"
                                                    inputRef={register}
                                                />
                                            }
                                            classes={{ label: classes.label, root: classes.labelRoot }}
                                            label={t('information_message.is_the_service_active_on_the_system')}
                                        />
                                    </GridItem>
                                    {
                                        session?.habilitaControleRoyalties &&
                                        <GridItem xs={12} sm={12} md={4}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        tabIndex={-1}
                                                        checked={incluirRoyaltieCheckbox}
                                                        onClick={event => { setIncluirRoyaltieCheckbox(event.target.checked) }}
                                                        checkedIcon={<Check className={classes.checkedIcon} />}
                                                        icon={<Check className={classes.uncheckedIcon} />}
                                                        classes={{ checked: classes.checked, root: classes.checkRoot }}
                                                        name="incluirRoyaltie"
                                                        inputRef={register}
                                                    />
                                                }
                                                classes={{ label: classes.label, root: classes.labelRoot }}
                                                label={t('information_message.does_the_service_control_royalts')}
                                            />
                                        </GridItem>
                                    }
                                </GridContainer>
                                <GridContainer>
                                    <label style={{ paddingLeft: '1.25rem', paddingTop: '1.25rem' }}>
                                        {'* Campo não brigatório. Selecionar somente se o serviço tiver uma clausula específica!'} 
                                    </label>
                                    <GridItem xs={12} sm={6} md={6}>
                                        <br></br>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <label className={errors.clausulaContrato ? "select__label select__label_error" : "select__label"}>{t('label.contract_clause')} </label>
                                            <Select
                                                classNamePrefix="select"
                                                styles={ValidSelect(errors.clausulaContrato ? true : false)}
                                                isSearchable={true}
                                                isLoading={loadingSelectClausula}
                                                name="clausulaContrato"
                                                placeholder={t('label.select') + " ..."}
                                                options={listSelectClausula}
                                                value={listSelectClausula.filter(({ clausulaContratoId }) => clausulaContratoId === clausulaContrato)}
                                                getOptionLabel={({ descricao }) => descricao}
                                                getOptionValue={({ clausulaContratoId }) => clausulaContratoId}
                                                onChange={(value) => handleClausulaChange(value.clausulaContratoId !== null ? value.clausulaContratoId : "")}
                                                ref={() => register(
                                                    { name: "clausulaContrato" })
                                                }
                                            />
                                        </FormControl>
                                    </GridItem>
                                </GridContainer>
                                <GridContainer>
                                    {showSelectEstabelecimento &&
                                        <GridItem xs={12} sm={12} md={12}>
                                            <div style={{ border: '1px dashed #ccc', padding: '20px' }}>

                                                <GridContainer>
                                                    <GridItem xs={12} sm={6} md={6}>
                                                        <h3>{t('register.access_establishment')}</h3>
                                                    </GridItem>
                                                    <GridItem xs={12} sm={6} md={6} style={{ textAlign: 'right' }}>
                                                        <Button color="primary" round onClick={() => handleClickSelecionarTodosEstabelecimentos()}   >
                                                            {t('button.to_save')}
                                                        </Button>
                                                    </GridItem>
                                                </GridContainer>

                                                <br />
                                                <FormControl fullWidth className={classes.formControl}>

                                                    <label className={errors.estabelecimentos ? "select__label select__label_error" : "select__label"}>Estabelecimentos </label>
                                                    {loadingSelectEstabelecimentos && <div className="loadingitemVenda">
                                                        <CircularProgress size={20} />
                                                    </div>}
                                                    {!loadingSelectEstabelecimentos &&
                                                        <Select
                                                            classNamePrefix="select"
                                                            isSearchable={true}
                                                            placeholder={t('label.select') + " ..."}
                                                            isMulti={true}
                                                            name="estabelecimentos"
                                                            isLoading={loadingSelectEstabelecimentos}
                                                            options={listSelectEstabelecimentos}
                                                            getOptionLabel={({ descricao }) => descricao}
                                                            getOptionValue={({ estabelecimentoId }) => estabelecimentoId}
                                                            value={listSelectEstabelecimentos.filter(({ estabelecimentoId }) => estabelecimentos.indexOf(estabelecimentoId) != -1)}
                                                            onChange={(value) => handleEstabelecimentoChange(value || [])}
                                                            ref={() => register({ name: "estabelecimentos" })}
                                                        />
                                                    }
                                                    <FormHelperText className={classes.labelRootError}>
                                                        {errors.estabelecimentos && <span>{t('label.select_an_establishment')}</span>}
                                                    </FormHelperText>
                                                </FormControl>
                                            </div>
                                        </GridItem>}
                                </GridContainer>
                                <Clearfix />
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
                <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                        <div className={classes.textCenter}>
                            <Button onClick={() => handleViewForm()} color="transparent" className={classes.updateProfileButton}>
                                {t('button.cancel')}
                            </Button>
                            <Button type="submit" color="primary" className={classes.updateProfileButton}>
                                {t('button.to_save')}
                                {loading && <div>{t('label.loading') + "..."}</div>}
                            </Button>
                        </div>
                    </GridItem>
                </GridContainer>
            </form>
        </div>
    );
}